<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
 import { checkVersion, unCheckVersion } from 'version-rocket'
import { version } from '../package.json'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'App',
  computed: {
    isLoggedIn() {
      return this.$store.state.user.isLoggedIn
    },
   
  },
  watch: {
    isLoggedIn(newVal) {
         if (newVal) {
          this.startPolling()
        } else {
          this.stopPolling()
        } 
    },
  },
  created(){
    if (this.isLoggedIn) {
      this.startPolling()
    }
     if (process.env.NODE_ENV === 'production') {
      checkVersion({
        localPackageVersion: version,
        originVersionFileUrl: `${location.origin}/version.json`
      }, {
        title: '发现新版本',
        // description: `V ${version}已经准备就绪！`,
        buttonText: '刷新'
      })
    }
  },
  methods:{
    ...mapActions(['startPolling', 'stopPolling']),

  },
    beforeDestroy() {
    if (process.env.NODE_ENV === 'production') {
      unCheckVersion({ closeDialog: false })
    }
  }
}

</script>

<style>

</style>
